export const objectBaseInfo = {
  "customerLoginAccount":'客户用户名',
  "customerName":"客户姓名",
  "dictBoutique":"是否精品",
  "productName":"借款产品",
  "loanAmt":"借款金额（元）",
  "dictShowFlag":"是否上架",
  "SelfLoanTerm":"借款期限",
  "loanRate":"借款利率",
  "recommend":"首页推荐",
  "dictReturnMethod":"还款方式",
  "dictProjectStatus":"标的状态",
  "raiseTerm":"募集期(天)",
  "createTime":"创建时间",
  'guaranteeCustomerName':'担保户',
  "qlTime":"流标时间",
};

export const editObjectBaseInfo = {
  "customerLoginAccount":'客户用户名',
  "customerName":"客户姓名",
  "dictBoutique":"是否精品",
  "productName":"借款产品",
  "loanAmt":"借款金额（元）",
  "dictShowFlag":"是否上架",
  "SelfLoanTerm":"借款期限",
  "loanRate":"借款利率",
  "recommend":"首页推荐",
  "dictReturnMethod":"还款方式",
  "dictProjectStatus":"标的状态",
  // "qlTime":"流标时间",
  "raiseTerm":"募集期(天)",
  "createTime":"创建时间",
  // 'guaranteeCustomerId':'担保户'
};

export const objectProperty = {
  "projectName":'标的名称',
  "preRaiseTimePeriod":"预计销售时间",
  "investMin":"起投金额（元）",
  "investIncrement":"出借递增金额（元）",
  "Rate":"出借利率",
  "serviceFee":"服务费率",
  "investMaxSum":"累计购买最大金额（元）",
  // "guaranteeCustomerId":"担保户",
};

export const templateDesc = '<p class="MsoNormal"><span style="font-size:10.5ptpx">1.项目名称:</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">富农项目/创业项目</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">2.项目规模/出借金额:</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">以标的实际募集金额为准(最高20万)。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">3.项目期限：</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">以标的期限为准,最长不超过1年。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">4.项目募集期:</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">72小时(自项目发布之时起算)。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">募集期内,已募资金自动冻结。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">5.最小出借金额/最高出借金额:</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">最小10000元,最高以标的实际额度为准。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">6.项目成立日:</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">发标72小时内满标当日。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">项目成立后,不支持出借人将出借本金退回(流标或借款人最终放弃借款的除外)。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">7.项目不成立:</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">项目发布后,若满72小时且未满标,将自动撤销。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">8.项目起息日:</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">借款客户实际到账日(非募集日)。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">9.项目兑付期:</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">T+1项目兑付期:(T指借款人实际还款日,非合同约定还款日,遇节假日顺延),项目兑付期不计算收益。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">10.还款方式:</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">利随本清:90天(含)以内到期后本金和利息一起归还。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">按月付息:90天以上次月起按月付息,到期一次性还本,结息日为每月20号。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">11.项目预期回报:</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">出借金额x出借实际天数x预期出借年利率÷365。(预期出借年利率是指借款人与出借人双方直接约定的年化借款利率。)</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">12.提现、充值手续费:</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">平台充值、提现手续费暂免。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">网银及其它渠道充值根据各机构收费标准。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">13.提前还款:</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">出借人不允许提前赎回或在未到期的情况下提前进行债权转让,但允许借款人提前还款给出借人,或者借款人到期未正常还款的债权转让给第三方机构,借款人提前还款根据借款合同约定按预计待还利息的一定比例缴纳违约金,违约金归出借人所有。违约金计算方式和费率详见借款合同。</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">14.项目居间机构:</span></p ><p class="MsoNormal"><span style="font-size:10.5ptpx">温岭市民间融资规范管理服务中心有限公司,按照监管规定,平台作为撮合方,仅提供信息中介居间服务,不对任何客户提供本息出借的任何担保承诺。</span></p >';
